import React from 'react';
import parse from 'html-react-parser';
import { useIntl } from 'react-intl';


const AlertInfo = props => {

    const {
        id = 'common.no_text',
        shouldParse = false,
        skipIntl = false,
        textReplacements = {}
    } = props;

    const intlApi = useIntl();

    let processedMessage;

    if(skipIntl) {
        processedMessage = id;
    } else {
        processedMessage = intlApi.formatMessage(
            { id },
            { ...textReplacements }
        );
    }

    const text = shouldParse ? parse(processedMessage) : processedMessage;

    return (
        <div className="usa-alert usa-alert--info gi-alert gi-alert__info">
            <div className="usa-alert__body gi-alert__info__body">
                <p className="usa-alert__text gi-alert__info__text">
                    { text }
                </p>
            </div>
        </div>
    );
};

export default AlertInfo;